export const LOAD_TEMPLATE = 'LOAD_TEMPLATE';
export const SET_TEMPLATE_PAGINATION = 'SET_TEMPLATE_PAGINATION';
export const ADD_TEMPLATE = 'ADD_TEMPLATE';
export const LOAD_EDITTABLE_TEMPLATE = 'LOAD_EDITTABLE_TEMPLATE';
export const SET_EMPTY_EDITTABLE_TEMPLATE = 'SET_EMPTY_EDITTABLE_TEMPLATE';
export const EDIT_TEMPLATE = 'EDIT_TEMPLATE';
export const SET_TEMPLATE_FILTER = 'SET_TEMPLATE_FILTER';
export const RESET_TEMPLATE_FILTERS = 'RESET_TEMPLATE_FILTERS';
export const SET_CHECKED_TEMPLATES = 'SET_CHECKED_TEMPLATES';
export const TOGGLE_TEMPLATE_STATUS = 'TOGGLE_TEMPLATE_STATUS';
export const CHECKED_TEMPLATES = 'CHECKED_TEMPLATES';
export const ADD_BULK_PACKAGES_FOR_TEMPLATE = 'ADD_BULK_PACKAGES_FOR_TEMPLATE';
export const DELETE_BULK_PACKAGES_FOR_TEMPLATE = 'DELETE_BULK_PACKAGES_FOR_TEMPLATE';
export const LOAD_PACKAGES_FOR_TEMPLATE = 'LOAD_PACKAGES_FOR_TEMPLATE';
export const UPDATE_PACKAGES_TO_LIST = 'UPDATE_PACKAGES_TO_LIST';
export const LOAD_EDITTABLE_PACKAGES_FROM_TEMPLATE = 'LOAD_EDITTABLE_PACKAGES_FROM_TEMPLATE';
export const SET_CHECKED_PACKAGES_FOR_TEMPLATE = 'SET_CHECKED_PACKAGES_FOR_TEMPLATE';
export const SET_PACKAGE_PAGINATION_FOR_TEMPLATE = 'SET_PACKAGE_PAGINATION_FOR_TEMPLATE';
export const SET_PACKAGE_PAGINATION_CHOOSEN = 'SET_PACKAGE_PAGINATION_CHOOSEN';
export const SET_FILTER_PACKAGE_FOR_CONFIGURATION = 'SET_FILTER_PACKAGE_FOR_CONFIGURATION';
export const RESET_PACKAGE_FILTERS_FOR_TEMPLATE = 'RESET_PACKAGE_FILTERS_FOR_TEMPLATE';
export const RESET_PACKAGE_FROM_TEMPLATE = 'RESET_PACKAGE_FROM_TEMPLATE';
export const RESET_PACKAGE_PAGINATION_FROM_TEMPLATE = 'RESET_PACKAGE_PAGINATION_FROM_TEMPLATE';
export const RESET_PACKAGE_PAGINATION_LIST = 'RESET_PACKAGE_PAGINATION_LIST';
export const SET_PACKAGE_SORT_FOR_TEMPLATE = 'SET_PACKAGE_SORT_FOR_TEMPLATE';
export const CLONE_PACKAGES_TO_TEMPLATE = 'CLONE_PACKAGES_TO_TEMPLATE';
export const LOAD_DESIGN_TEMPLATES = 'LOAD_DESIGN_TEMPLATES';
export const SET_DESIGN_TEMPLATES_PAGINATION = 'SET_DESIGN_TEMPLATES_PAGINATION';
export const LOAD_EDITABLE_DESIGN_TEMPLATES = 'LOAD_EDITABLE_DESIGN_TEMPLATES';
export const SET_EMPTY_EDITABLE_DESIGN_TEMPLATES = 'SET_EMPTY_EDITABLE_DESIGN_TEMPLATES';
export const LOAD_RESELLERS_FOR_DESIGN_TEMPLATES = 'LOAD_RESELLERS_FOR_DESIGN_TEMPLATES';
export const LOAD_PRODUCT_GROUPS_FOR_DESIGN_TEMPLATES = 'LOAD_PRODUCT_GROUPS_FOR_DESIGN_TEMPLATES';
export const EDIT_DESIGN_TEMPLATE = 'EDIT_DESIGN_TEMPLATE';
export const UPDATE_TRANSLATE_DESIGN_TEMPLATES = 'UPDATE_TRANSLATE_DESIGN_TEMPLATES';
